import { SALES_TYPES } from '../../constants';

import salesEditComponentUrl from './salesEditComponent.html';

class SalesEdit {
  constructor(SalesService, $scope) {
    'ngInject';

    Object.assign(this, { SalesService, $scope });
  }

  $onInit() {
    this.$scope.$watch('ctrl.sale', () => {
      if (this.sale) {
        this.calculateLaborPercentage();
      }
    });
  }

  getEmptySale() {
    return this.SalesService.getEmptyProjectedSale(SALES_TYPES.override, this.locationId, this.day);
  }

  _recalculateProjectedSales(oldVal = 0, newVal = 0) {
    const balance = Number(newVal) - Number(oldVal);
    this.totals.projectedSales = this.totals.projectedSales
      ? this.totals.projectedSales + balance
      : balance;
    this.calculateLaborPercentage();
  }

  async saveProjectedSale(initialValue, sale) {
    const editedSale = await this.SalesService.saveSingleSale(sale);
    const newAmount = editedSale.amount || editedSale.default;

    this._recalculateProjectedSales(initialValue, newAmount);
    this.onChange?.();
  }
}

export default {
  templateUrl: salesEditComponentUrl,
  controller: SalesEdit,
  controllerAs: 'ctrl',
  bindings: {
    sale: '=',
    totals: '=',
    locationId: '@',
    day: '@',
    inactive: '<?',
    onToggleFocus: '&',
    onChange: '&?',
    calculateLaborPercentage: '&',
  },
};
